import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import fetchModuleGroup from '../../actions/ModuleGroupActions';
import { getModule, getModuleGroup } from '../../selectors/moduleGroupSelectors';

import './SmallTopBanner.less';

export const SkinnyBannerView = ({ banner, loadModuleGroup, moduleGroup, tag }) => {
  useEffect(() => {

    // Only load the module group if it isn't already in the store
    if (tag && !moduleGroup) {
      loadModuleGroup(tag);
    }
  }, [loadModuleGroup, moduleGroup, tag]);

  return (banner && (
    <div className="col-xs-12 col-md-12 banner-promo-module">
      <a href={banner.link_path} rel="noopener noreferrer">
        <span>{banner.link_label}</span>
      </a>
    </div>)
  ) || null;
};

SkinnyBannerView.propTypes = {
  activeCardEvent: PropTypes.string,
  banner: PropTypes.shape({}),
  loadModuleGroup: PropTypes.func.isRequired,
  moduleGroup: PropTypes.shape({}),
  tag: PropTypes.string,
};

const isSkinnyBannerModule = module => module.title && module.title.startsWith('SkinnyBanner -');

const mapStateToProps = (state, ownProps) => {
  const props = {
    ...ownProps,
    searchFn: isSkinnyBannerModule,
  };

  return {
    moduleGroup: getModuleGroup(state, props),
    banner: getModule(state, props)
  };
};

const mapDispatchToProps = dispatch => ({
  loadModuleGroup: tag => dispatch(fetchModuleGroup(tag)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SkinnyBannerView);



// WEBPACK FOOTER //
// ./src/components/promotions/SkinnyBanner.jsx